//
// This file is auto generated. See ./README.md for details
//
import React from 'react'
import { Icon as ChakraIcon } from '@chakra-ui/react'
import {
  HubResponsiveValue,
  StandardIconSizes,
  HubStyleObject,
  forwardRef,
} from '@hub/design-system-base'
import { WestfieldDirectSwooshMediumSVG } from './svg'

interface WestfieldDirectSwooshMediumIconProps {
  boxSize?: HubResponsiveValue<StandardIconSizes>
  sx?: HubStyleObject
}

export const WestfieldDirectSwooshMediumIcon: React.FC<WestfieldDirectSwooshMediumIconProps> = forwardRef<
  WestfieldDirectSwooshMediumIconProps,
  typeof ChakraIcon
>(({ boxSize = 'size-icon-sm', sx }, ref) => (
  <ChakraIcon
    ref={ref}
    boxSize={boxSize}
    as={WestfieldDirectSwooshMediumSVG}
    sx={sx}
  />
))
